// @flow

import type { AddGrossRentLimitsFormValues } from './types';

export const WIZARD_STEP = {
  NEW_GROSS_RENT_LIMITS: 0,
  CONFIRMATION: 1,
};

export const ACTIVE_STEP_INDEX_FIRST = WIZARD_STEP.NEW_GROSS_RENT_LIMITS;
export const ACTIVE_STEP_INDEX_LAST = WIZARD_STEP.CONFIRMATION;

export const WIZARD_MODAL_WIDTH_PX = 881;

export const DEFAULT_FORM_VALUES: AddGrossRentLimitsFormValues = {
  effectiveDate: null,
  anticipatedVoucherMonth: null,
  autoCalculatedAnticipatedVoucherMonth: null,
  floorPlanChanges: {},
};
